<template>
    <div class="app">
        <scroll>
            <div v-if="isJudge" class="title">请选择需要签约的用户</div>
            <ul class="user">
               <li v-for="(item,index) in userInfoList" @click="choose(index)">
                    <span class="radio" :class="{active:current==index}"></span>
                    <span class="left">{{item.holderName}}</span>
                    <span class="center">{{item.certNo}}</span>
                    <span class="right">
                        <span :class="{blue: item.signState =='已签约', red: item.signState =='未签约',green: item.signState =='审核中'}">{{item.signState}}</span>
                    </span>
               </li>
            </ul>
            <div class="ok-wrap" v-if="isJudge">
               <button id="feedback-submit" class="btn-ok" type="button" @click="go()">确认</button>
            </div>
            <no-record id="myregister-norecord" :condition="userInfoList" tips='抱歉，没有签约记录' ></no-record>
        </scroll>
    </div>
</template>

<script>
    import NoRecord from 'NoRecord'
    import voucherService from 'voucher.service'
    import regionService from 'region.service'
    export default {
        components:{
            NoRecord,
        },
        data(){
            return {
                userInfoList:[],
                current:0,
                isJudge:true,
                voucherList:[],
            }
        },
        mounted() {
            this.getUserInfo()
        },
        beforeRouteLeave(to,from,next) {
            from.meta.keepAlive = false
            next()
        },
        methods: {
            choose(index) {
                this.current = index;
            },
            /**
             * 获取用户信息
             * @return {[type]} [description]
             */
            getUserInfo () {
                voucherService.getVoucherList().then((res) => {
                    if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                        this.userInfoList = []
                        this.isJudge = false
                        return;
                    }
                    const data = res.data;
                    if (data.length === 0) {
                        this.$utils.alert('请先绑定诊疗卡');
                        this.isJudge = false
                        this.$router.replace('profile')
                        return;
                    }
                    this.voucherList = data;
                    /*eslint-disable*/
                    let promises = []
                    for (var i = 0; i < this.voucherList.length; i++) {
                        promises.push(this.getSignStatus(this.voucherList, i))
                    }
                    Promise.all(promises).then(()=>{
                        if(this.voucherList.length === 0){
                            this.userInfoList = []
                            this.isJudge = false
                            return
                        }
                        this.userInfoList = this.voucherList
                        for(var i = 0 ;i<this.userInfoList.length;i++) {
                            this.userInfoList[i].certNo = this.userInfoList[i].certNo.substr(0, 4) + '*****' + this.userInfoList[i].certNo.substr(14)
                        }
                    })
                },()=>{
                })
            },
            /**
             * 获取签约状态
             * @param  {[type]} current [description]
             * @return {[type]}         [description]
             */
            getSignStatus(list, index) {
                return regionService.loadSignStatus({
                    idcard: list[index].certNo
                }).then((res) => {
                    if(res.stateCode === 203) {
                        this.voucherList[index].signState = this.transStateStr(res.data)
                        res.idcard = this.voucherList[index].certNo
                        res.userName = this.voucherList[index].holderName
                        res.phone = this.voucherList[index].mobileNo
                        this.voucherList[index].signInfo = res
                        return
                    }
                    this.voucherList[index].signState = this.transStateStr(res.data.state)
                    this.voucherList[index].signInfo = res.data
                })
            },
            transStateStr(state) {
                if(!state && state !== 0) {
                    state = ''
                }
                switch (state) {
                    case '':
                        return '未签约'
                    case 0:
                        return '审核中'
                    case 1:
                        return '审核中'
                    case 2:
                        return '审核中'
                    case 3:
                        return '已签约'
                }
            },
            go() {
                let state = this.userInfoList[this.current].signState
                if(state == '已签约'){
                    this.$router.push({
                        name: 'Signed',
                        query: this.userInfoList[this.current].signInfo
                    });
                }else if(state == '未签约') {
                    this.$router.push({
                        name: 'NoSigned',
                        query: this.userInfoList[this.current].signInfo
                    });
                }else if(state == '审核中'){
                    this.$router.push({
                        name: 'Review',
                        query: this.userInfoList[this.current].signInfo
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .app{
        background-color: #EFF3F6;
        padding-bottom:3.75rem;
       .title {
            color:#666666;
            height: 2.0rem;
            line-height: 2.0rem;
            padding: 0 0.5rem;
        }
        .user{
            margin-top: 0.1rem;
            background-color: #fff;
            color: #333333;
            li {
                display: flex;
                justify-content: space-between;
                height: 2.25rem;
                line-height: 2.25rem;
                border-bottom: 0.025rem solid #EFF3F6;
                padding: 0 0.5rem;
                .radio{
                    position: relative;
                    top: 0.65rem;
                    width: 0.85rem;
                    height: 0.85rem;
                    border-radius: 0.85rem;
                    border: 0.025rem solid #CDCDCD;

                    &:after{
                        position: absolute;
                        content:'';
                        width: 0.45rem;
                        height: 0.45rem;
                        left:50%;
                        top:50%;
                        margin-top: -0.225rem;
                        margin-left: -0.225rem;
                        border-radius: 0.45rem;
                        background-color: #CDCDCD;
                    }

                    &.active {
                        border: 0.025rem solid #5C95FF;
                        &:after{
                           background-color: #5C95FF;
                        }
                    }
                }
                .left{
                    width: 3.0rem;
                    overflow:hidden;
                    white-space:nowrap;
                    text-overflow: ellipsis;
                    margin-left: 0.5rem;
                }
                .center{
                    flex-grow: 1;
                }

                .right {
                    .blue {
                        color: #1FA9F0;
                    }
                    .red {
                        color: #FD6C6D;
                    }
                    .green {
                        color: #57D3BA;
                    }
                }
            }
        }
        .ok-wrap{
            position: fixed;
            height: 2.5rem;
            bottom: 0.5rem;
            left: 0.5rem;
            right: 0.5rem;
            .btn-ok {
               letter-spacing:1px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// FamilyDoctor.vue?ba0ca4a4